import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { sendToSupervisor /*fetchAndSetTrademarkTypes*/ } from '../WorkviewActions'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import '../WorkviewManager.scss'
import FormSelectionList from './FormSelectionList'
import EntitySelectionList from './EntitySelectionList'
import {
  defaultRecordSearchQuery,
  SET_RECORD_SEARCH_QUERY,
  SET_SEARCH_RESULTS,
  SET_STAFF_DRAFT,
  SET_AMENDMENT_WIZARDS,
} from '../../WVManager/Workview2Reducer'
import * as api from '../../../requests'
import { useHistory } from 'react-router'
import { Spinner } from '../../Loaders/Loaders'
import WVMNotes from '../../Notes/WVMNotes'

const PaperProccessModal = ({ navToCorrespondence, refreshView, closePaperModalUnlockItem }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { selectedRow } = useSelector((state) => state.workview2, shallowEqual)
  const [showNoPaymentConfirm, setShowNoPaymentConfirm] = useState(false)
  const [loadingNoPaymentData, setLoadingNoPaymentData] = useState(false)

  const openWizard = () => {
    const { SelectedFormDefinitionId, RecordToAmend, SelectedFormStaffDraft } = selectedRow
    // determine redirect
    let redirect = null
    if (
      RecordToAmend &&
      (RecordToAmend['File #'] ||
        RecordToAmend['Filing #'] ||
        RecordToAmend['Trademark #'] ||
        RecordToAmend['Commission Number'] ||
        RecordToAmend['Filing Number'] ||
        RecordToAmend['Record Number'] ||
        RecordToAmend['License #'] ||
        RecordToAmend['Record #'] ||
        RecordToAmend['Registration #'])
    ) {
      const sourceNum =
        RecordToAmend['File #'] ||
        RecordToAmend['Trademark #'] ||
        RecordToAmend['Filing #'] ||
        RecordToAmend['Commission Number'] ||
        RecordToAmend['Filing Number'] ||
        RecordToAmend['Record Number'] ||
        RecordToAmend['License #'] ||
        RecordToAmend['Record #'] ||
        RecordToAmend['Registration #']
      redirect = `/office/workview/${
        SelectedFormStaffDraft ? 'draft/' : ''
      }process/${SelectedFormDefinitionId}/${sourceNum}`
    } else {
      redirect = `/office/workview/${
        SelectedFormStaffDraft ? 'draft/' : ''
      }process/${SelectedFormDefinitionId}`
    }
    history.push(redirect)
  }

  useEffect(() => {
    setLoadingNoPaymentData(true)
    api.DOES_IMAGE_ENVELOPE_HAVE_PAYMENT(
      selectedRow.ImageEnvelopeId,
      (hasPayment) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(!hasPayment)
      },
      (err) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(false)
        console.error(err.Message)
      }
    )
  }, [selectedRow.ImageEnvelopeId])

  useEffect(() => {
    const {
      IsInitialFiling,
      SelectedFormDefinitionId,
      SelectedFormStaffDraft,
      RecordToAmend,
      Filing,
      FormDefinitionId,
      DLN,
    } = selectedRow

    if (
      (IsInitialFiling || (RecordToAmend && !RecordToAmend.FilingNum)) &&
      SelectedFormDefinitionId
    ) {
      openWizard()
    } else if (SelectedFormDefinitionId && RecordToAmend && RecordToAmend.FilingNum) {
      if (Filing.Num && FormDefinitionId) {
        api.DELETE_ASSOCIATED_AMENDMENT(
          DLN,
          () => {},
          (err) => {
            console.error(err.Message)
          }
        )
      }
      history.push(
        `/office/workview/process/${
          SelectedFormStaffDraft ? 'draft/' : ''
        }${SelectedFormDefinitionId}/${RecordToAmend.FilingNum}`
      )
    } else if (SelectedFormDefinitionId || RecordToAmend) {
      console.warn(
        'The Selected Form/Entity with the current workview item does not meet redirect requirements. Contact admin for further instructions.'
      )
    }
  }, [selectedRow])

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_SEARCH_RESULTS,
        results: [],
      })
      dispatch({
        type: SET_RECORD_SEARCH_QUERY,
        query: defaultRecordSearchQuery,
      })
      dispatch({
        type: SET_AMENDMENT_WIZARDS,
        amendmentWizards: [],
        loadingAmendmentWizards: false,
      })
      dispatch({ type: SET_STAFF_DRAFT, staffDraft: null })
    }
  }, [])

  const showFormSelection = useMemo(() => {
    if (loadingNoPaymentData) return false
    return (
      selectedRow.IsInitialFiling ||
      (selectedRow.RecordToAmend && selectedRow.RecordToAmend.SourceID)
    )
  }, [selectedRow, loadingNoPaymentData])

  const showEntitySelection = useMemo(() => {
    if (loadingNoPaymentData) return false
    return (
      !selectedRow.IsInitialFiling &&
      (!selectedRow.RecordToAmend ||
        !(selectedRow.RecordToAmend && selectedRow.RecordToAmend.SourceID))
    )
  }, [selectedRow, loadingNoPaymentData])

  return (
    <div className="wvm-modal">
      <div className="flex-column-wrapper paper-process-container">
        {loadingNoPaymentData && <Spinner className="page-loader" themeColor="neutral" />}
        {showEntitySelection && <EntitySelectionList />}
        {showFormSelection && <FormSelectionList />}
      </div>
      {showNoPaymentConfirm && (
        <div className="no-payment-warning">No Payment found in Image Envelope.</div>
      )}
      <WVMNotes />
      <ContextButtonControl
        navToCorrespondence={navToCorrespondence}
        refreshView={refreshView}
        closePaperModalUnlockItem={closePaperModalUnlockItem}
      />
    </div>
  )
}

export const ContextButtonControl = ({
  disableSubmitButton = false,
  showSubmitButton = false,
  onSubmit = null,
  navToCorrespondence,
  refreshView,
  closePaperModalUnlockItem,
}) => {
  const { selectedRow } = useSelector((state) => state.workview2, shallowEqual)
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const dispatch = useDispatch()
  // const allowApostilleCorrections = useAppSetting('AllowApostilleCorrections', {
  //   cache: true,
  // })

  const supervisor = () => {
    dispatch(
      sendToSupervisor(selectedRow.WorkViewItemId, () => {
        closePaperModalUnlockItem()
        refreshView()
      })
    )
  }

  return (
    <ContextBar
      elevation="standard"
      customCss={{ marginBottom: '15px' }}
      className="granite-context-bar"
    >
      <div className="context-button-wrapper">
        <ContextButton
          onClick={() => navToCorrespondence(selectedRow, 1)}
          variant="danger"
          className={
            !appUserRights.includes(`FileRejection`) || !selectedRow.AllowRejections ? 'hidden' : ''
          }
        >
          Reject
        </ContextButton>
        <ContextButton
          onClick={() => navToCorrespondence(selectedRow, 2)}
          variant="secondary"
          className={
            !appUserRights.includes(`FileCorrection`) || !selectedRow.AllowCorrections
              ? 'hidden'
              : ''
          }
        >
          Correct
        </ContextButton>
        <ContextButton
          disabled={selectedRow.ProcessingStatusName === 'Supervisor Review'}
          onClick={supervisor}
          variant="secondary"
        >
          Supervisor Review
        </ContextButton>
        <ContextButton
          onClick={onSubmit ? onSubmit : () => {}}
          variant="primary"
          className={!showSubmitButton ? 'hidden' : ''}
          disabled={disableSubmitButton}
        >
          Submit
        </ContextButton>
      </div>
    </ContextBar>
  )
}

export default PaperProccessModal
